import { ReactComponent as Logo } from '@assets/icons/logo.svg';
import { useMainContext } from '@context/Main';
import React from 'react';
import * as styles from './styles';

const LogoContainer = () => {
  const { currentBanner } = useMainContext();

  return (
    <div css={styles.container}>
      {currentBanner ? <div /> : <p css={styles.text}>{'굿닥 비대면진료'}</p>}
      <Logo css={styles.logo} />
    </div>
  );
};

export default LogoContainer;
